// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Label(Props) {
  var children = Props.children;
  var className = Props.className;
  return React.createElement("label", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "label",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* [] */0
                    ]
                  ])
            }, children);
}

var make = Label;

exports.make = make;
/* react Not a pure module */
